import React from 'react';

const EnergyIcon = ({ backgroundFill, fillColor, strokeColor, strokeWidth, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      fill={backgroundFill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      width={width}
    >
      <path d="M12.3,1.4L3,12.9c-.1.1,0,.6.2.6h9c.1,0,.2.1.2.2l-3,8.7c0,.2.2.3.4.2l11.9-13.2c.1-.1,0-.3-.2-.3h-9.7c-.1,0-.2,0-.2-.2l1.1-7.3c0-.2-.2-.3-.4-.1h0Z" />
    </svg>
  );
};

export default EnergyIcon;
